import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/common/Header";
import { InboxSection } from "../../features/quickblox";

const Inbox = () => {
  return (
    <>
      <Helmet>
        <title>Inbox - GigFalcon</title>
        <meta
          name="description"
          content="Access your messages and conversations on GigFalcon. Stay connected with clients and freelancers."
        />
      </Helmet>
      <Header />
      <div
        className="border-top-50 border d-flex overflow-auto"
        style={{ height: "calc(100vh - 70px)" }}
      >
        <InboxSection />
      </div>
    </>
  );
};

export default Inbox;
